/*Package importing*/
import React, { Component } from 'react';

/*Components*/
import CardTwoColumn from './column-2';
import CardThreeColumn from './column-3';
import CardFourColumn from './column-4';
import CardSixColumn from './column-6';

class List extends Component {
  constructor(props){
    super(props);
    this.state = {
      
    }
  }

  componentDidMount() {
    
  }

  render() {


    return (
        <div className="container px-0 e-list-preview">
            {
                this.props.info.data.type ==1?
                <CardFourColumn data={this.props.info.data.content} type={this.props.info.data.style.value} bg_color={this.props.info.header.bg_color} />
                :this.props.info.data.type ==2?
                <CardSixColumn data={this.props.info.data.content} type={this.props.info.data.style.value} bg_color={this.props.info.header.bg_color} />
                :this.props.info.data.type ==3?
                <CardTwoColumn data={this.props.info.data.content} type={this.props.info.data.style.value} bg_color={this.props.info.header.bg_color} />
                :this.props.info.data.type ==4?
                <CardThreeColumn data={this.props.info.data.content} type={this.props.info.data.style.value} bg_color={this.props.info.header.bg_color} />
                :
                null
            }
        </div>
    );
  }
}

export default List;
